module.exports = __webpack_public_path__ + "static/media/x-circle.0a814f41.svg";